import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCw0A9tJV2AqTZkgg9r8eviDOt-jwFZXSU",
  authDomain: "university-management-ba43b.firebaseapp.com",
  projectId: "university-management-ba43b",
  storageBucket: "university-management-ba43b.firebasestorage.app",
  messagingSenderId: "729036587042",
  appId: "1:729036587042:web:40bb59e8241df0420c0a7b",
  measurementId: "G-DWSZX91Z7X"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
